module.exports = __webpack_public_path__ + "img/instagram_logo.1e183c4f.png";